// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowExpanderLeft16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-expander-left': IconArrowExpanderLeft;
    }
}

/**
 * The icon component for the 'arrowExpanderLeft' icon
 */
export class IconArrowExpanderLeft extends IconSvg {
    public constructor() {
        super(arrowExpanderLeft16X16);
    }
}

registerIconSvg('icon-arrow-expander-left', IconArrowExpanderLeft);
export const iconArrowExpanderLeftTag = 'nimble-icon-arrow-expander-left';
